<template>
    <div class="text-xs-center">
        <p class="pt-1 secondary--text">{{$t('label.or')}}</p>
        <v-container fluid fill-height :dark="false">
        <v-layout align-center justify-center>
          <v-flex xs9 sm5 md8 lg5 xl4>
            <v-card hover @click="loginWithGoogle()" color="white">
                <v-card-title class="pa-0 pa-1">
                    <v-layout row wrap justify-center align-center>
                        <v-flex xs2 md2 class="pa-1">
                            <v-img src="@/assets/google-icon.png" ></v-img>
                        </v-flex>
                        <v-flex xs10 md10 class="" >
                            <v-card-text  class="pa-0 greyDarken3--text">
                                {{$t('screener.login_with_google.title')}}
                            </v-card-text>
                        </v-flex>
                    </v-layout>
                </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
</template>
<script>
import * as firebase from "firebase";
export default {
    name: 'SocialLogin',
    methods: {
        async loginWithGoogle(){
            const provider = new firebase.auth.GoogleAuthProvider()
            firebase.auth().signInWithPopup(provider).
            then(async (response) => {
                this.$emit('onSuccess',response)
            })
            .catch((error) => {
                 console.error('Google authentication failed',error)
            })
        },


    }
}
</script>
